// extracted by mini-css-extract-plugin
module.exports = {"singleSearchGun":"SingleSearchGun_singleSearchGun__2bCxI","imgWrapper":"SingleSearchGun_imgWrapper__1fcSl"};